import React, { useRef, useEffect } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';

const AboutHero = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const videoRef = useRef<HTMLVideoElement>(null);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });
  
  // Parallax: Video läuft linear mit halber Scrollgeschwindigkeit mit. Eine Easing-Kurve hier lässt das
  // Video anfangs fast 1:1 mitlaufen und dann stehenbleiben, das wirkt beim Scrollen wie ein Springen.
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['0%', '50%']);
  
  // Apply grayscale filter to the video
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error("Video autoplay failed:", error);
      });
    }
  }, []);

  return (
    <section
      ref={containerRef}
      className="relative h-screen overflow-hidden bg-black text-white"
    >
      {/* Subtle background text */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.05] pointer-events-none overflow-hidden">
        <span className="text-[40vw] font-black whitespace-nowrap select-none">YADE</span>
      </div>
      
      {/* Video background with parallax effect */}
      <motion.div
        className="absolute inset-0 w-full h-full z-0"
        style={{ y, willChange: 'transform' }}
      >
        <video 
          ref={videoRef}
          className="object-cover absolute inset-0 w-full h-full filter grayscale"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="https://videos.pexels.com/video-files/31532185/13439861_2560_1440_30fps.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Dark overlay to improve text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>
      </motion.div>

      {/* Content */}
      <div className="relative z-20 container mx-auto px-6 h-full flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="max-w-4xl"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Wir gestalten Lebensräume der Zukunft.
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl">
            Bei YADE Home GmbH verbinden wir Menschen mit ihren Traumimmobilien durch Expertise, Leidenschaft, Vertrauen und einen Blick nach vorn.
          </p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <button className="bg-[#00C2CC] hover:bg-[#00a0a8] transition-colors text-white px-8 py-3 text-lg font-medium rounded-full">
              Unsere Immobilien entdecken
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutHero;
